import {
  BottomNavigation,
  BottomNavigationAction,
  Box,
  Divider,
} from '@mui/material';
import { getMarketDisplayLabel } from 'src/utils/markets';

interface MarketsNavigationFiltersProps {
  rankings?: { code?: string }[];
}

interface MarketsNavigationProps {
  value: string;
  handleSelectMarket: (value: string) => void;
  filters?: Record<string, MarketsNavigationFiltersProps>;
  markets?: string[];
  marketLabels?: Record<string, string>;
  disabledMarkets?: string[];
}

const MarketsNavigation = ({
  value,
  handleSelectMarket,
  filters,
  markets = ['CR', 'CRI', 'CRA', 'FII', 'FIDC', 'FIAGRO', 'DEBENTURES'],
  marketLabels,
  disabledMarkets = [],
}: MarketsNavigationProps) => {
  const isCRmarket = value?.toLowerCase() === 'cr';

  return (
    <Box>
      <BottomNavigation
        value={value}
        onChange={(_, newValue) => {
          handleSelectMarket(newValue);
        }}
        showLabels
        sx={(theme) => ({
          height: 48,
          width: 'max-content',
          justifyContent: 'flex-start',
          [theme.breakpoints.down('sm')]: { width: 'auto' },
        })}>
        {markets?.map((market, index) => (
          <BottomNavigationAction
            key={`${market}-${index}`}
            label={marketLabels?.[market] ?? getMarketDisplayLabel(market)}
            value={market}
            disabled={Boolean(
              disabledMarkets.includes(market) ||
                (isCRmarket &&
                  market === 'CR' &&
                  filters?.CR?.rankings &&
                  !filters?.CR?.rankings?.length),
            )}
          />
        ))}
      </BottomNavigation>
      <Divider />
    </Box>
  );
};

export default MarketsNavigation;
